import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

function useIsOwner() {
    const authIdSelector = (state) => state.auth.data.id;
    const userIdSelector = (state) => state.profilePage.userInfo.userId;
    const selectedData = createSelector(
        [authIdSelector, userIdSelector], (authId, userId) => {
            return {
                authId,
                userId,
            }
        }
    );
    const state = useSelector(selectedData);
    return state.authId === state.userId;
};

export default useIsOwner;